import React from "react";
import { InPageEditableSectionField } from "./types";
import { InPageEditableField } from "./InPageEditableField";
import classNames from "classnames";
import SupportQuestionMark from "supportbeacon/SupportQuestionMark";

interface Props {
  field: InPageEditableSectionField
  compact: boolean
}

const InPageEditableFieldWithLabel = ({ field, compact }: Props) => {
  const hasSublabel = field.sublabel != null;

  const title = `${field.label}${hasSublabel ? `\n${field.sublabel}` : ""}`;

  return <>
    {!field.hideLabel && <div title={title} ref={field.ref} className={classNames("main-section-template-fields-label", field.labelClassName, {
      "flex gap": field.supportArticleId,
      "sublabel": hasSublabel
    })}>
      {field.label}
      {field.supportArticleId && <SupportQuestionMark small articleId={field.supportArticleId} />}
      {hasSublabel && <div className="s1_small">{field.sublabel}</div>}
    </div>}
    <InPageEditableField compact={compact} field={field} />
  </>
}

export default InPageEditableFieldWithLabel;